import React, { useEffect } from "react";
import { BankAccountChildProps } from "../../types/props";
import { BANK_ACCOUNT_FLOW_TYPES, ICONS } from "../../constants/enums";
import i18n from "../../i18n/config";
import { useHistory } from "react-router-dom";
import { ROUTES } from "../../constants/clientRoutes";
import { useSelector } from "react-redux";
import { getFormValues } from "redux-form";
import { FORM_NAMES } from "../../constants/forms";
import { RootState } from "../../types/redux";

import ActionLink from "../../components/Common/ActionLink";
import Icon from "../../components/Common/Icon";
import Alert from "../../components/Common/Alerts/Alert";

import { BankAccountFormValues } from "../../types/forms";
const Confirmed = (props: BankAccountChildProps) => {
  const formValues = useSelector((state: RootState) => getFormValues(FORM_NAMES.BANK_ACCOUNTS)(state)) as BankAccountFormValues;
  const { type } = useSelector((state: RootState) => state.bankAccounts);
  const { setTitle } = props;
  const history = useHistory();
  const subtitleText = type === BANK_ACCOUNT_FLOW_TYPES.NEW ? i18n.t("PAGES.BANK_ACCOUNTS.CONFIRMED.ADD") : i18n.t("PAGES.BANK_ACCOUNTS.CONFIRMED.EDIT");

  useEffect(() => {
    const title = type === BANK_ACCOUNT_FLOW_TYPES.NEW ? i18n.t("PAGES.BANK_ACCOUNTS.CONFIRMED.TITLE.ADD") : i18n.t("PAGES.BANK_ACCOUNTS.CONFIRMED.TITLE.EDIT");
    setTitle(title);
  }, [type]);

  return (
    <div className="text-center max-w-350 mx-auto mt-24">
      <Icon icon={ICONS.GREEN_CHECK} className="w-32 mb-8" />
      <p className="font-size-lg marengo-grey">
        {i18n.t("PAGES.BANK_ACCOUNTS.CONFIRMED.P1")}{" "}
        <span className="bold">{formValues?.BeneficiaryName}</span>
        {" "}{subtitleText}.
      </p>
      <Alert
        alertClasses={"alert-info mb-8 flex-row align-items-start text-left"}
        icon={ICONS.INFO}
        iconClasses={"spacing-right-tiny"}
      >
        <p className="navy-blue bold">{i18n.t("COMMON.IMPORTANT")}</p>
        <p>{i18n.t("PAGES.BANK_ACCOUNTS.CONFIRMED.ALERT.P1")} <span className="bold">{i18n.t("PAGES.BANK_ACCOUNTS.CONFIRMED.ALERT.BOLD_TEXT")}</span>.</p>
      </Alert>

      <ActionLink
        text={i18n.t("COMMON.DONE")}
        clickFunc={() => history.push(ROUTES.BANKS_ACCOUNTS.INDEX)}
        classes="btn btn-primary mt-8 w-full"
      />
    </div>
  );
}

export default Confirmed;